import { CL289_COUNTRY_PLACE_OF_LOADING_NOT_REQUIRED } from 'shared/ncts/common/constants'
import { COUNTRY_CODE_PREFIX, removePrefix } from 'shared/ncts/common/classifier-util'
import { RuleResult } from '../../../../types/DeclarationP5'

const C0409Validator = {
  validatePlaceOfLoadingRequirement: ({
    additionalDeclarationType,
    departureCustomsOffice,
  }: {
    security: string
    additionalDeclarationType: string
    departureCustomsOffice: string
  }): RuleResult => {
    if (additionalDeclarationType === 'D') return 'OPTIONAL'

    const departureCountry = removePrefix(departureCustomsOffice, COUNTRY_CODE_PREFIX) ?? ''

    return CL289_COUNTRY_PLACE_OF_LOADING_NOT_REQUIRED.includes(departureCountry)
      ? 'OPTIONAL'
      : 'REQUIRED'
  },
}

export default C0409Validator
